import { render, staticRenderFns } from "./integralMallDecoration.vue?vue&type=template&id=2ddf97b4&scoped=true"
import script from "./integralMallDecoration.vue?vue&type=script&lang=js"
export * from "./integralMallDecoration.vue?vue&type=script&lang=js"
import style0 from "./integralMallDecoration.vue?vue&type=style&index=0&id=2ddf97b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf97b4",
  null
  
)

export default component.exports